
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";

export function LanguageSync() {
    const { i18n } = useTranslation();

    // Fetch current user data
    const { data: user } = useQuery<{ language: string }>({
        queryKey: ["/api/auth/user"],
        retry: false,
        staleTime: 5 * 60 * 1000, // 5 minutes
    });

    useEffect(() => {
        // Only proceed if we have user data and a valid language
        if (user && i18n.language) {
            const clientLang = i18n.language.split('-')[0];
            const serverLang = user.language;

            // Supported languages list
            const supportedLangs = ['en', 'fr', 'es'];

            // If client language is supported AND differs from server language
            if (supportedLangs.includes(clientLang) && clientLang !== serverLang) {
                console.log(`[LanguageSync] Mismatch detected. Client: ${clientLang}, Server: ${serverLang}. Syncing...`);

                apiRequest("PATCH", "/api/auth/language", { language: clientLang })
                    .then(() => {
                        console.log("[LanguageSync] Language synced successfully");
                        // Optionally invalidate query to update local cache, 
                        // though not strictly necessary if we trust the sync
                    })
                    .catch(err => console.error("[LanguageSync] Failed to sync language:", err));
            }
        }
    }, [user, i18n.language]);

    return null; // This component renders nothing
}
